import './stylea.css';
const Pop = () => {
    return (
        <div class="container">
        <div class="bulle">
          <p>Une erreur Technique est survenue sur notre site,
                  Veuillez nous excuser pour la g&ecirc;ne occasionn&eacute;e</p>  
        </div>
        </div>
    );
};
export default Pop;
